import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'

export const EasyPaySignupPage: FC = () => {
  const { t } = useTranslation('easyPaySignupPage')

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
    >
    </ContentLayout>
  )
}
